import axios from 'axios';
import { MembershipEndpoints } from './constants';

class MembershipService {
  static async getMembershipData(slug: string) {
    const url = MembershipEndpoints.getMembershipData(slug);
    const rest = await axios.get(url);

    return rest.data;
  }
}

export default MembershipService;
